<template>
  <f7-page name="dashboard" ref="page">
    <f7-navbar :sliding="false">
      
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" href="/panel-left/"></f7-link>
        <!--<f7-nav-left back-link="Back">-->
      </f7-nav-left>

      <f7-nav-title sliding>{{ $t('Dashboard') }}</f7-nav-title>

      <f7-nav-right>
        <f7-link icon-only href="/notifications/">
          <f7-icon icon="f7-icons icon-notifications">
            <f7-badge v-if="NewNotificationsCount !== 0" color="red">{{ NewNotificationsCount }}</f7-badge>
          </f7-icon>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block-title>{{ $t('AllDevices') }}</f7-block-title>
    <f7-block v-if="isSolutionStatsLoaded && solutionStats.length" strong>
      <f7-row>
        <f7-col v-for="item in solutionStats"
                width="50"
                small="33"
                large="auto"
                :key="`card-devices-solution-stat-${ item.name }`">
          <div class="card margin-bottom dashboard-card">
            <div class="card-header">
              {{ item.name }}
              <span v-if="item.hint" v-tooltip="item.hint"><i class="f7-icons icon-hint text-color-lightblue size-20" ></i></span></div>
            <div class="card-content card-content-padding text-color-white" :class="item.bgColor">
              <div class="display-flex justify-content-space-between">
                <div class="">
                  {{ numeralFormat(item.value) }}
                </div>
                <div v-if="item.valueSecond">
                  {{ numeralFormat(item.valueSecond, '+0,0') }}
                </div>
              </div>
            </div>
          </div>
        </f7-col>
      </f7-row>
    </f7-block>
    <f7-block v-else-if="isSolutionStatsLoaded && !solutionStats.length" strong>
      <p>{{ $t('NoAssetsFound') }}</p>
    </f7-block>
    <f7-block v-else strong>
      <f7-row>
        <f7-col v-for="item in 6" width="50" small="33" large="auto" :key="`skeleton-all-devices-${item}`">
          <div class="card margin-bottom skeleton-text skeleton-effect-wave">
            <div class="card-header">header</div>
            <div class="card-content card-content-padding text-color-white " >
              <div class="display-flex justify-content-space-between">
                <div class="">
                  value
                </div>
                <div class="">
                  value
                </div>
              </div>
            </div>
          </div>
        </f7-col>
      </f7-row>
    </f7-block>

    <dashboard-activations />

    <dashboard-deactivations v-if="isDeactivationSupported" />

    <dashboard-sms-usage />

    <f7-block>
      <f7-row v-if="isUsageOverviewLoaded">
        <f7-col v-for="item in simStats"
                width="50"
                small="33"
                large="auto">
          <div class="card margin-bottom dashboard-card">
            <div class="card-header">{{ item.name }}</div>
            <div class="card-content card-content-padding text-color-white" :class="item.bgColor">
              <div class="display-flex justify-content-space-between">
                <div class="">
                  {{ numeralFormat(item.value, item.numeralFormat) }}
                </div>
                <div class="">
                  {{ item.valueSecond }}
                </div>
              </div>
            </div>
          </div>
        </f7-col>
      </f7-row>
      <f7-row v-else>
        <f7-col v-for="item in 4" width="50" :key="item">
          <div class="card margin-bottom skeleton-text skeleton-effect-wave">
            <div class="card-header">header</div>
            <div class="card-content card-content-padding text-color-white" :class="item.bgColor">
              <div class="display-flex justify-content-space-between">
                <div class="">
                  value
                </div>
                <div class="">
                  value
                </div>
              </div>
            </div>
          </div>
        </f7-col>
      </f7-row>
    </f7-block>

    <f7-block-title>{{ $t('TotalSIMOnline') }}</f7-block-title>
    <f7-list v-if="isUsageOverviewLoaded">
      <f7-list-item
          :title="$t('Today')"
          :after="numeralFormat(UsageOverview.ONLINE_DAY)"
      >
      </f7-list-item>
      <f7-list-item
          :title="$t('LastWeek')"
          :after="numeralFormat(UsageOverview.PRE_ONLINE_WEEK)"
      >
      </f7-list-item>
      <f7-list-item
          :title="$t('LastMonth')"
          :after="numeralFormat(UsageOverview.PRE_ONLINE_MONTH)"
      >
      </f7-list-item>
    </f7-list>
    <f7-list v-else>
      <f7-list-item
          v-for="item in 3"
          title="title"
          after="number"
          class="skeleton-text skeleton-effect-wave"
          :key="`skeleton-total-sim-online-${item}`"
      >
      </f7-list-item>
    </f7-list>

    <f7-block-title>{{ $t('AverageSimUsage') }}</f7-block-title>
    <f7-list v-if="isUsageOverviewLoaded">
      <f7-list-item
          :title="$t('Today')"
          :after="numeralFormat(UsageOverview.DATA_DAY / UsageOverview.ONLINE_DAY, '0.0 b')"
      >
      </f7-list-item>
      <f7-list-item
          :title="$t('LastWeek')"
          :after="numeralFormat(UsageOverview.PRE_DATA_WEEK / UsageOverview.PRE_ONLINE_WEEK, '0.0 b')"
      >
      </f7-list-item>
      <f7-list-item
          :title="$t('LastMonth')"
          :after="numeralFormat(UsageOverview.PRE_DATA_MONTH / UsageOverview.PRE_ONLINE_MONTH, '0.0 b')"
      >
      </f7-list-item>
    </f7-list>
    <f7-list v-else>
      <f7-list-item
          v-for="item in 3"
          title="title"
          after="number"
          class="skeleton-text skeleton-effect-wave"
          :key="`skeleton-average-sim-usage-${item}`"
      >
      </f7-list-item>
    </f7-list>



    <f7-block v-if="isCreditsDisplayed">
      <div class="card margin-bottom dashboard-card">
        <div class="card-header">
          {{ $t('Credits') }}
        </div>
        <div class="card-content card-content-padding" >
          <div class="display-flex justify-content-space-between">
            <div class="">
              {{ UserInfo.SMSTimes }}
            </div>
            <div class="row">
              <f7-link href="/credits/recharge/" class="button button-fill button-small color-green col min-width-80 margin-right">{{ $t('Buy') }}</f7-link>
              <f7-link href="/credits/transfer/" class="button button-fill button-small color-yellow col min-width-80" :class="{disabled: !UserInfo.SMSTimes}">{{ $t('Xfer') }}</f7-link>
            </div>
          </div>
        </div>
      </div>
    </f7-block>



  </f7-page>
</template>


<script>
import {mapGetters} from "vuex";
import {QTAPI} from "../../services/qt-api";

import DashboardSmsUsage from "./components/dashboard-sms-usage"
import DashboardActivations from "./components/dashboard-activations"
import DashboardDeActivations from "./components/dashboard-deactivations"
import DashboardDeactivations from "./components/dashboard-deactivations";
import {theme} from "framework7-vue";

let updateInterval = null

export default {
  name: "dashboard",

  components: {
    DashboardDeactivations,
    DashboardSmsUsage,
    DashboardActivations,
    DashboardDeActivations
  },

  data(){

    return {
      //isLoadingDashboard: false,
      isSolutionStatsLoaded: false,
      isUsageOverviewLoaded: false,
      isCreditsDisplayed: false,

      autoUpdateTimer: 60,

      solutionStats: [],
      simStats: [],
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'NewNotificationsCount', 'AllSolutionStats', 'ActivatedPerDay', 'UsageOverview', 'UserInfo', 'UserInfoPreEdit']),
    isDeactivationSupported(){
      return this.UserInfoPreEdit?.Solutions?.findIndex(itm => itm.Value.toLowerCase() === 'deactivate') > -1
    }
  },

  async mounted() {
    this.getDashboardData()
    this.getUsageOverviewData()
    //this.getDashboardData2()

    updateInterval = setInterval(() => {
      this.getDashboardData()
      this.getUsageOverviewData()
      //this.getDashboardData2()
    }, this.autoUpdateTimer * 1000)

    let additionalFlags = await this.$store.dispatch('getFromStorage', 'additionalFlags')
    this.isCreditsDisplayed = !theme.ios ? true : !!additionalFlags?.elemRc
    //console.log(additionalFlags?.elemRc)
  },

  unmounted() {
    if(updateInterval){
      clearInterval(updateInterval)
    }
  },

  watch: {

    AllSolutionStats(items) {
      //console.log(items)
      const onStock = {
        name: 'OnStock',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-18',
        hint: 'NonActivated & Unknown'
      }
      const deActivated = {
        name: 'DeActivated',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-1'
      }
      const protect = {
        name: 'Protect',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-2'
      }
      const qProtect = {
        name: 'QProtect',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-3'
      }
      const loc8 = {
        name: 'Loc8',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-4'
      }
      const boatWatch = {
        name: 'BoatWatch',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-8'
      }
      const track = {
        name: 'Track',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-5'
      }
      const watch = {
        name: 'Watch',
        value: 0,
        valueSecond: 0,
        bgColor: 'bg-custom-color-6'
      }

      if (items && items.length) {
        for (const [key, value] of Object.entries(items)) {
          switch (value.SOLUTION) {
            case 'Unknown':
            case 'NonActivated':
              onStock.value += value.Numbers;
              break;
            case 'Protect':
            case 'WiTiProtect':
              protect.value += value.Numbers;
              break;
            case 'Boat_watch':
            case 'BoatWatch':
              boatWatch.value += value.Numbers;
              break;
            case 'DeActivate':
              deActivated.value += value.Numbers;
              break;
            default:
              let solution = value.SOLUTION.toLowerCase()
              if (solution.indexOf('protect') > -1) qProtect.value += value.Numbers;
              if (solution.indexOf('loc8') > -1) loc8.value += value.Numbers;
              if (solution.indexOf('track') > -1) track.value += value.Numbers;
              if (solution.indexOf('watch') > -1) watch.value += value.Numbers;
          }
        }
      }

      if (this.ActivatedPerDay && this.ActivatedPerDay.length) {
        for (const [key, value] of Object.entries(this.ActivatedPerDay)) {
          switch (value.Solution) {
            case 'Unknown':
            case 'NonActivated':
              onStock.valueSecond += value.Number;
              break;
            case 'Protect':
            case 'WiTiProtect':
              protect.valueSecond += value.Number;
              break;
            case 'Boat_watch':
            case 'BoatWatch':
              boatWatch.valueSecond += value.Number;
              break;
            case 'DeActivate':
              deActivated.valueSecond += value.Number;
              break;
            default:
              let solution = value.Solution.toLowerCase()
              if (solution.indexOf('protect') > -1) qProtect.valueSecond += value.Number;
              if (solution.indexOf('loc8') > -1) loc8.valueSecond += value.Number;
              if (solution.indexOf('track') > -1) track.valueSecond += value.Number;
              if (solution.indexOf('watch') > -1) watch.valueSecond += value.Number;
          }
        }
      }

      this.solutionStats = [protect, qProtect, loc8, track, watch, boatWatch, deActivated, onStock].filter(itm => itm.value > 0)
      this.isSolutionStatsLoaded = true
    },

    UsageOverview(data){
      this.simStats = [
        {
          name: this.$t('DataSessions'), //'Data Sessions',
          value: data.SESSION_DAY,
          bgColor: 'bg-custom-color-9',
          numeralFormat: ''
        },
        {
          name: this.$t('DataUsage'), //'Data Usage',
          value: data.DATA_DAY,
          bgColor: 'bg-custom-color-10',
          numeralFormat: '0.0 b'
        },
        {
          name: this.$t('SMSUsage'), //'SMS Usage',
          value: data.SMS_MO_DAY + data.SMS_MT_DAY,
          bgColor: 'bg-custom-color-11',
          numeralFormat: ''
        },
        {
          name: this.$t('OnlineNumbers'), //'Online Numbers',
          value:  data.ONLINE_DAY,
          bgColor: 'bg-custom-color-12',
          numeralFormat: ''
        },
      ]
    },
  },

  methods: {
    async getDashboardData(){
      //this.isLoadingDashboard = true
      let result = await QTAPI.GetDashboardInfo({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken
      });
      //this.isLoadingDashboard = false
      //console.log(result)
    },
    async getUsageOverviewData(){
      //this.isUsageOverviewLoaded = true
      let result = await QTAPI.GetUsageOverview({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken
      });
      this.isUsageOverviewLoaded = true
      //console.log(result)
    },
    /*async getDashboardData2(){
      let result = await QTAPI.GetDashboardInfo2({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken
      });
    },*/
  }
}
</script>

<style scoped>

</style>